import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import Scenario1PivBadge, { scenario1PivBadgeAudioCaching, scenario1PivBadgeVideoSegments } from "../../../scenario1-piv-badge";
import { PivBadgeComponentsStep0ComponentMainConfig, PivBadgeComponentsStep0ComponentPart1Config } from "../piv-badge-components-step0";

export default class PivBadgeComponentsStep0Part1 extends BaseScenarioPart<GameBaseScenario> {
	private get config(): PivBadgeComponentsStep0ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: PivBadgeComponentsStep0ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	private stepName = 'Step 1';

	public start() {
		// this.scenario.uiWrapper.displayAAR();
		this.section1();
	}

	public section1() {
		const context = this;
		let chapter = context.config.chapter;
		context.playVideoChapter(chapter(), () => {
			context.section2();
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			questionTitle: 'Select the one that best describes the employee’s action',
			audioUrl: scenario1PivBadgeAudioCaching.getItemByKey(scenario1PivBadgeAudioCaching.audioKeys.question1).src,
			options: [
				{
					title: 'Human Error',
					description: `
						<ul>
						<li>The employee is not accountable.</li>
						<li>The employee should be consoled.</li>
						<li>The employee should be interviewed and consulted during any systems level analysis.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Laura did not commit an 
						error while working appropriately and in the patient’s best interest.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'At Risk Behavior',
					description: `
						<ul>
						<li>The employee is accountable and should receive coaching.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is the Correct choice. Laura made a risky choice that was faulty or 
						self-serving. It may even be considered a routine rule violation.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Reckless Behavior',
					description: `
						<ul>
						<li>Discipline may be warranted.</li>
						<li>The employee is accountable and should receive re-training/coaching as necessary.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best choice. Laura’s behavior is risky. She knowingly 
						violated a rule, and the choice was risky. She demonstrated concern about the risk, but 
						elected to take the risk anyway, thinking it was justified because she was only going to 
						be gone for a few minutes. When she returned, she was contrite about the situation, and 
						did demonstrate concern about the risk.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				if((this.mainConfig.scenario as Scenario1PivBadge).comp1Step1FirstSelectedChoiceIndex === -1) {
					(this.mainConfig.scenario as Scenario1PivBadge).comp1Step1FirstSelectedChoiceIndex = allOptions.indexOf(selectedChoices[0]);
				}
				const mentorInfo = scenario1PivBadgeVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 1 '), parentQuestionConfig, () => {
					this.section3();
				}, () => {
					this.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[0], mentorInfo.chapterIds[1], mentorInfo.chapterIds[2], 'Human Error');
			}
		}, 0);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the correct answer, what is the appropriate path to take with the employee',
			audioUrl: scenario1PivBadgeAudioCaching.getItemByKey(scenario1PivBadgeAudioCaching.audioKeys.question2).src,
			options: [
				{
					title: 'Console',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the most complete option. In Just Culture, employees 
						are to be consoled if their behavior was considered a human error.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console and coach',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. This is needed for employee’s actions that are considered “at-risk behavior.”</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Console, coach, and consider discipline',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option at this step.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				if((this.mainConfig.scenario as Scenario1PivBadge).comp1Step1FirstSelectedChoiceIndex === -1) {
					(this.mainConfig.scenario as Scenario1PivBadge).comp1Step1FirstSelectedChoiceIndex = allOptions.indexOf(selectedChoices[0]);
				}
				const mentorInfo = scenario1PivBadgeVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[3], mentorInfo.chapterIds[4], mentorInfo.chapterIds[5], 'Console');
			}
		}, 1);
	}
}